import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CompanyPage {
  id?: string;
  subslug: string;
  pricingPageUrl: string | null;
  screenshotUrl: string | null;
  screenshotUrlVersion: string | null;
  pricing_metrics?: any[]; // Snake case version from API
  pricingMetrics?: any[]; // Camel case version that might be used
  scrapes?: any[]; // Add scrapes field to store scrapes data
  tags?: any[]; // Add tags field
}

export interface PricingMetric {
  id: string;
  slug: string;
  display_name: string;
  modality: string | null;
  subcategory: string | null;
  sample_values: string[] | null;
  sample_prices: string[] | null;
  created_at: string | null;
}

export interface Company {
  id?: string;
  slug: string;
  logoUrl: string | null;
  employees: string;
  category: string;
  description: string | null;
  url: string | null;
  legacySlug: string | null;
  pricingMetrics: PricingMetric[];
  pages: CompanyPage[];
  metrics?: any[]; // Add metrics field for backward compatibility
  tags?: any[]; // Add tags field
  scraper?: string; // Add scraper field for screenshot method
}

interface CompanyState {
  company: Company | null;
  loading: boolean;
  error: string | null;
}

const initialState: CompanyState = {
  company: null,
  loading: false,
  error: null
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompany: (state, action: PayloadAction<Company>) => {
      state.company = action.payload;
      state.loading = false;
      state.error = null;
    },
    setCompanyLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCompanyError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearCompany: (state) => {
      state.company = null;
      state.loading = false;
      state.error = null;
    }
  }
});

export const { setCompany, setCompanyLoading, setCompanyError, clearCompany } = companySlice.actions;

export default companySlice.reducer;
